module.exports = __webpack_public_path__ + "static/media/dataInput.2070a3eb.svg";